import { defaultTheme as calendarTheme } from '../Calendar/theme';

/* eslint-disable key-spacing */
export const defaultDateTimeInputTheme = {
  calendar:             calendarTheme,
  calendarIcon:         'datepicker-calendar-icon',
  iconsWrapper:         'datepicker-icons-wrapper',
  input:                'datepicker-input',
  inputWrapper:         'datepicker-input-wrapper',
  inputWrapperFocused:  'focused',
  inputWrapperInvalid:  'danger',
  inputWrapperRequired: 'required',
  wrapper:              'datepicker-wrapper',
  wrapperDisabled:      'disabled-state',
};
/* eslint-enable key-spacing */
